import {Alert} from '@material-ui/lab'
import {useDispatch, useSelector} from 'react-redux'
import {RouteComponentProps} from 'react-router-dom'
import RoutineForm from 'src/components/RoutineForm'
import Routine from 'src/models/Routine'
import {RootState} from 'src/redux/rootReducer'
import {useEffect, useState} from 'react'
import {ActionSelectors, ActivitySelectors, GoalSelectors} from 'src/redux/selectors'
import {actions as routinesActions} from 'src/redux/modules/routines'
import {actions as actionsActions} from 'src/redux/modules/actions'

export type TParams = {id: string}

export type RoutineEditProps = RouteComponentProps<TParams> & {}

const {selectActions} = ActionSelectors
const {selectActivities} = ActivitySelectors
const {selectGoals} = GoalSelectors

const RoutineEdit: React.FC<RoutineEditProps> = ({match, history}: RoutineEditProps) => {
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const {routines, dataState} = useSelector((state: RootState) => state.routines)
  const actionsState = useSelector((state: RootState) => state.actions)
  const allActions = useSelector(selectActions)
  const allActivities = useSelector(selectActivities)
  const allGoals = useSelector(selectGoals)

  const dispatch = useDispatch()

  let invalidID = !match.params || !match.params.id

  let routine = undefined
  if (!invalidID) {
    // Get the routine ID back from the match.
    const routineIDString = match.params.id

    // Find the routine with this ID.
    routine = routines.find((u: Routine) => u.id === routineIDString)
  }

  // When the user clicks save, and the routine-form form has verified the data, we
  // come back here.
  const onSaveRoutine = (updatedRoutine: Routine, imageFile: File | undefined) => {
    // Save the routine.
    dispatch(routinesActions.saveRoutine({routine: updatedRoutine, imageFile: imageFile}))

    // Set the flag
    setIsSaving(true)
  }

  const onCancelRoutine = () => {
    // Back to the routines page.
    history.goBack()
  }

  useEffect(() => {
    if (isSaving && dataState.state !== 'loading') {
      // Finished saving.
      setIsSaving(false)

      if (!dataState.error) {
        // And no error!
        setIsSuccess(true)
      }
    }
  }, [isSaving, dataState, history])

  invalidID = invalidID || !routine

  if (invalidID) {
    return <Alert severity="error">Invalid RoutineID.</Alert>
  } else {
    if (actionsState.dataState.state === 'unloaded') {
      // We need to load the actions.
      dispatch(actionsActions.getAllActions())
    }

    const busyString = isSaving
      ? 'Saving Routine...'
      : actionsState.dataState.state === 'loading' || dataState.state === 'loading'
      ? 'Loading routines & actions...'
      : undefined

    const successString = isSuccess ? 'Routine Updated!' : undefined

    return (
      <RoutineForm
        onSaveRoutine={onSaveRoutine}
        onCancel={onCancelRoutine}
        onDismissSuccess={() => history.goBack()}
        title="Edit Routine"
        allActions={allActions}
        allActivities={allActivities}
        allGoals={allGoals}
        busyString={busyString}
        errorMessage={dataState.error?.message}
        editRoutine={routine}
        successString={successString}
      />
    )
  }
}

export default RoutineEdit
